;(() => {
  // Prevent multiple initializations
  if (window.cartRecommendationsInitialized) {
    return
  }
  window.cartRecommendationsInitialized = true

  const Splide = window.Splide || null
  let isInitializing = false

  // Global function to initialize cart recommendations slider
  window.initCartRecommendationsSlider = () => {
    if (isInitializing) {
      return null
    }
    const sliderElement = document.getElementById("cart-recommendations-slider")
    if (!sliderElement) {
      return null
    }
    if (!Splide) {
      console.warn("Splide library not loaded")
      return null
    }
    isInitializing = true

    try {
      // Check if slider is already initialized
      if (sliderElement.splide) {
        try {
          sliderElement.splide.destroy()
        } catch (error) {
          console.error("Error destroying existing slider:", error)
        }
      }

      const splideInstance = new Splide("#cart-recommendations-slider", {
        type: "loop",
        perPage: 3.5,
        perMove: 1,
        gap: "5px",
        padding: "0",
        arrows: true,
        pagination: false,
        waitForTransition: false, // Prevent flickering
        speed: 300,
      })

      splideInstance.mount()
      sliderElement.splide = splideInstance

      // Initialize quick add after slider is fully ready
      setTimeout(() => {
        if (typeof window.initAllQuickAdd === "function") {
          window.initAllQuickAdd()
        }
        isInitializing = false
      }, 100)

      return splideInstance
    } catch (error) {
      console.error("Error initializing cart recommendations slider:", error)
      isInitializing = false
      return null
    }
  }

  // Global function to initialize quick add for all products in slider
  window.initAllQuickAdd =
    window.initAllQuickAdd ||
    (() => {
      // Wait for DOM to be stable
      setTimeout(() => {
        const productWrappers = document.querySelectorAll(
          "#cart-recommendations-slider .splide__slide, .cart-recommendations .splide__slide",
        )

        if (productWrappers.length === 0) {
          return
        }

        productWrappers.forEach((slideElement, index) => {
          const productWrapper =
            slideElement.querySelector(".custom-product__wrapper") ||
            slideElement.querySelector('[class*="product__item--cart--"]') ||
            slideElement.querySelector(".product-wrapper") ||
            slideElement

          if (!productWrapper) {
            return
          }

          // Skip if already initialized
          if (productWrapper.dataset.quickAddInitialized === "true") {
            return
          }

          console.log("Product wrappers ------------------------------- ", productWrappers);

          const trigger = productWrapper.querySelector(".custom-product__cart-trigger")
          const selector = productWrapper.querySelector(".custom-product__dropdown-selector") // Updated selector
          const dropdownToggle = productWrapper.querySelector(".custom-product__dropdown-toggle") // Added for dropdown
          const dropdownMenu = productWrapper.querySelector(".custom-product__dropdown-menu") // Added for dropdown
          const addToCartButton = productWrapper.querySelector("[data-add-to-cart]")
          const hiddenSelect = productWrapper.querySelector('select[name="id"]')
          const errorMessage = productWrapper.querySelector("[data-error]")
          const selectedVariantTitle = productWrapper.querySelector(".selected__variant--title") // Added for variant title

          // Initialize cart trigger with debouncing to prevent flickering
          if (trigger && selector) {
            let triggerTimeout
            const triggerHandler = (e) => {
              e.preventDefault()
              e.stopPropagation()

              // Clear any existing timeout
              if (triggerTimeout) {
                clearTimeout(triggerTimeout)
              }

              // Debounce the action to prevent flickering
              triggerTimeout = setTimeout(() => {
                selector.classList.add("active")
              }, 50)
            }

            // Remove existing listener if any
            if (trigger.quickAddHandler) {
              trigger.removeEventListener("click", trigger.quickAddHandler)
            }

            trigger.addEventListener("click", triggerHandler)
            trigger.quickAddHandler = triggerHandler
          }

          // Initialize dropdown toggle
          if (dropdownToggle && dropdownMenu) {
            const dropdownHandler = (e) => {
              e.preventDefault()
              e.stopPropagation()
              dropdownMenu.classList.toggle("active")
            }

            // Remove existing listener if any
            if (dropdownToggle.quickAddHandler) {
              dropdownToggle.removeEventListener("click", dropdownToggle.quickAddHandler)
            }

            dropdownToggle.addEventListener("click", dropdownHandler)
            dropdownToggle.quickAddHandler = dropdownHandler
          }

          // Initialize dropdown options
          const dropdownOptions = productWrapper.querySelectorAll(".custom-product__dropdown-option")
          if (dropdownOptions.length > 0 && hiddenSelect) {
            dropdownOptions.forEach((option) => {
              let optionTimeout
              const optionHandler = function (e) {
                e.preventDefault()
                e.stopPropagation()

                // Clear any existing timeout
                if (optionTimeout) {
                  clearTimeout(optionTimeout)
                }

                // Debounce the action
                optionTimeout = setTimeout(() => {
                  const variantId = this.getAttribute("data-variant-id")
                  const isAvailable = this.getAttribute("data-variant-available") === "true"
                  const variantTitle = this.getAttribute("data-variant-title")

                  if (!isAvailable) {
                    showError("This variant is out of stock")
                    return
                  }

                  // Update selection
                  dropdownOptions.forEach((opt) => opt.classList.remove("active"))
                  this.classList.add("active")
                  hiddenSelect.value = variantId

                  // Update selected variant title if element exists
                  if (selectedVariantTitle) {
                    selectedVariantTitle.textContent = variantTitle
                  }

                  // Update dropdown toggle text
                  const variantTitleElement = dropdownToggle.querySelector(".custom-product__selected-variant")
                  if (variantTitleElement) {
                    variantTitleElement.textContent = variantTitle
                  }

                  // Update button state
                  if (addToCartButton) {
                    addToCartButton.disabled = !isAvailable
                  }

                  // Close dropdown menu
                  if (dropdownMenu) {
                    dropdownMenu.classList.remove("active")
                  }

                  // Dispatch change event
                  hiddenSelect.dispatchEvent(new Event("change", { bubbles: true }))
                }, 50)
              }

              // Remove existing listener if any
              if (option.quickAddHandler) {
                option.removeEventListener("click", option.quickAddHandler)
              }

              option.addEventListener("click", optionHandler)
              option.quickAddHandler = optionHandler
            })
          }

          // Initialize add to cart button
          if (addToCartButton) {
            const addToCartHandler = (e) => {
              e.preventDefault()
              e.stopPropagation()

              const variantId = hiddenSelect ? hiddenSelect.value : null
              if (!variantId) {
                showError("Please select a variant")
                return
              }

              addToCart(variantId, productWrapper)
            }

            // Remove existing listener if any
            if (addToCartButton.quickAddHandler) {
              addToCartButton.removeEventListener("click", addToCartButton.quickAddHandler)
            }

            addToCartButton.addEventListener("click", addToCartHandler)
            addToCartButton.quickAddHandler = addToCartHandler
          }

          // Close dropdown when clicking outside
          const outsideClickHandler = (e) => {
            if (
              dropdownMenu &&
              !dropdownMenu.contains(e.target) &&
              !dropdownToggle.contains(e.target) &&
              dropdownMenu.classList.contains("active")
            ) {
              dropdownMenu.classList.remove("active")
            }

            if (
              selector &&
              !selector.contains(e.target) &&
              !trigger.contains(e.target) &&
              selector.classList.contains("active")
            ) {
              selector.classList.remove("active")
            }
          }

          // Remove existing outside click handler if any
          if (productWrapper.outsideClickHandler) {
            document.removeEventListener("click", productWrapper.outsideClickHandler)
          }

          document.addEventListener("click", outsideClickHandler)
          productWrapper.outsideClickHandler = outsideClickHandler

          // Mark as initialized
          productWrapper.dataset.quickAddInitialized = "true"

          // Helper functions for this specific product
          function addToCart(variantId, wrapper) {
            const currentAddToCartButton = wrapper.querySelector("[data-add-to-cart]")
            const currentSelector = wrapper.querySelector(".custom-product__dropdown-selector")

            setLoadingState(true, currentAddToCartButton)

            const formData = new FormData()
            formData.append("id", variantId)
            formData.append("quantity", "1")

            fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "X-Requested-With": "XMLHttpRequest",
              },
              body: formData,
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`)
                }
                return response.json()
              })
              .then((data) => {
                if (currentSelector) {
                  currentSelector.classList.remove("active")
                }
                return fetch(`${window.Shopify.routes.root}?sections=cart-drawer`)
              })
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Failed to fetch cart sections")
                }
                return response.json()
              })
              .then((sections) => {
                setLoadingState(false, currentAddToCartButton)
                const cartDrawer = document.querySelector("cart-drawer")
                if (cartDrawer) {
                  const parsedState = { sections: sections }
                  cartDrawer.renderContents(parsedState)
                }
                updateCartCount()
              })
              .catch((error) => {
                setLoadingState(false, currentAddToCartButton)
                showError("Error adding product to cart. Please try again.")
                console.error("Add to cart error:", error)
              })
          }

          function setLoadingState(isLoading, button) {
            if (!button) return

            const addToCartText = button.querySelector(".add-to-cart-text")
            const loadingText = button.querySelector(".loading-text")

            if (addToCartText && loadingText) {
              addToCartText.style.display = isLoading ? "none" : "inline"
              loadingText.style.display = isLoading ? "inline" : "none"
            }

            button.disabled = isLoading
          }

          function updateCartCount() {
            fetch("/cart.js")
              .then((response) => response.json())
              .then((cart) => {
                const itemCount = cart.item_count
                const cartCountSelectors = [
                  ".cart-count-bubble",
                  ".cart-icon-bubble",
                  ".cart-count",
                  "[data-cart-count]",
                  ".header__icon--cart .cart-count",
                  ".cart-link .cart-count",
                ]

                cartCountSelectors.forEach((selector) => {
                  const elements = document.querySelectorAll(selector)
                  elements.forEach((element) => {
                    if (element) {
                      element.textContent = itemCount
                      element.style.display = itemCount > 0 ? "block" : "none"
                    }
                  })
                })
              })
              .catch((error) => {
                console.error("Error updating cart count:", error)
              })
          }

          function showError(message) {
            if (errorMessage) {
              errorMessage.textContent = message
              errorMessage.hidden = false
              setTimeout(() => {
                errorMessage.hidden = true
              }, 3000)
            } else {
              console.error("Error:", message)
            }
          }
        })
      }, 50) // Small delay to ensure DOM is stable
    })

  // Clean up function for all products
  window.cleanupAllQuickAdd =
    window.cleanupAllQuickAdd ||
    (() => {
      const productWrappers = document.querySelectorAll('[data-quick-add-initialized="true"]')

      productWrappers.forEach((wrapper) => {
        // Remove outside click handler
        if (wrapper.outsideClickHandler) {
          document.removeEventListener("click", wrapper.outsideClickHandler)
        }

        // Remove trigger handlers
        const trigger = wrapper.querySelector(".custom-product__cart-trigger")
        if (trigger && trigger.quickAddHandler) {
          trigger.removeEventListener("click", trigger.quickAddHandler)
        }

        // Remove dropdown toggle handlers
        const dropdownToggle = wrapper.querySelector(".custom-product__dropdown-toggle")
        if (dropdownToggle && dropdownToggle.quickAddHandler) {
          dropdownToggle.removeEventListener("click", dropdownToggle.quickAddHandler)
        }

        // Remove dropdown option handlers
        const dropdownOptions = wrapper.querySelectorAll(".custom-product__dropdown-option")
        dropdownOptions.forEach((option) => {
          if (option.quickAddHandler) {
            option.removeEventListener("click", option.quickAddHandler)
          }
        })

        // Remove add to cart handlers
        const addToCartButton = wrapper.querySelector("[data-add-to-cart]")
        if (addToCartButton && addToCartButton.quickAddHandler) {
          addToCartButton.removeEventListener("click", addToCartButton.quickAddHandler)
        }

        // Reset initialization flag
        wrapper.dataset.quickAddInitialized = "false"
      })
    })

  // Combined initialization function with better error handling
  window.initCartRecommendationsComplete = () => {
    // Check if recommendations section exists
    const recommendationsSection = document.querySelector(".cart-recommendations")
    if (!recommendationsSection) {
      return null
    }

    // First initialize the slider
    const sliderInstance = window.initCartRecommendationsSlider()

    // Always try to initialize quick add, even if slider fails
    setTimeout(() => {
      if (typeof window.initAllQuickAdd === "function") {
        window.initAllQuickAdd()
      }
    }, 200)

    return sliderInstance
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        window.initCartRecommendationsComplete()
      }, 200)
    })
  } else {
    setTimeout(() => {
      window.initCartRecommendationsComplete()
    }, 200)
  }
})()

// Separate event listener for initialization
window.addEventListener("DOMContentLoaded", () => {
  console.log("Splide recommendation cart....")
  window.initCartRecommendationsSlider()
})
